import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import VerifiNoticesAdmin from './VerifiNoticesAdmin';
import ClientDisputeNotices from '../ClientAlerts/ClientDisputeNotices';

export default function DisputeSwitcher() {
  const [{ user }] = useStateValue();

  if (user?.permissions?.includes(PERMISSIONS.ALERTS_ALL)) {
    return <VerifiNoticesAdmin caseType="DISPUTE_NOTICE" title="Dispute Notices (TC15)" />;
  }

  return <ClientDisputeNotices />;
}
